import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    description: {
      color: '#828282'
    },
    cardContent: {
      // display: 'flex',
      // flexGrow: 3,
      // flexDirection: 'column',
      paddingTop: '0px !important',
      height: '100%'
    },
    cardActionsRight: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  })
